import { useEffect } from 'react';

const useSetInterval = (fn: () => void, timeout: number, isEnabled = true): void => {
  useEffect(() => {
    if (isEnabled) {
      const intervalId = setInterval(fn, timeout);

      return () => clearInterval(intervalId);
    }
  }, [fn, timeout, isEnabled]);
};

export default useSetInterval;
